import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Body } from '../DefaultStyles/Details';
import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import ShareDrawer from '../../components/ShareDrawer';
import { Footer } from '../../containers/DefaultStyles/Shared';
import { PBVMFooter } from '../../components/Volunteer/Shared';
import {
    Container,
    FormHeader,
    ParentOrg,
    Step,
    Title,
    VolunteerFormWrapper
} from '../../components/Volunteer/Shared';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import VolunteerStep2Form from '../../components/Volunteer/VolunteerStep2Form';

import { onGoToStep } from './actions';
import { setOverlayPartnerVisible } from '../Widget/actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import volunteerMatchLogo from '../../assets/images/volunteermatch.png';

const VolunteerStep2 = props => (
    <TransitionContainer
        zIndex={3}
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <Overlay />
        <OverlayPublisher />
        <OverlayPartner transitionType="right-to-left" />
        <OverlayPartner
            logoIsSmall={false}
            transitionType="right-to-left"
            logo={volunteerMatchLogo}
            name={'About Volunteer Match'}
            description={
                "We believe everyone should have the chance to make a difference. That's why we make it easy for good people and good causes to connect. We've connected millions of people with a great place to volunteer and helped tens of thousands of organizations better leverage volunteers to create real impact."
            }
        />
        <Body>
            <WidgetHeader />
            <Container>
                <VolunteerFormWrapper>
                    <FormHeader>
                        <Title>Volunteer Signup</Title>
                        <Step>Step 1 of 2</Step>
                    </FormHeader>
                    <ParentOrg>{props.volunteerOpportunity.parentOrg.name}</ParentOrg>
                    <VolunteerStep2Form
                        volunteerOpportunity={props.volunteerOpportunity}
                        onBack={() => {
                            props.onGoToStep(2, 1);
                        }}
                        onSubmit={values => {
                            props.cacheFormData(values);
                            props.onGoToStep(2, 3);
                        }}
                    />
                </VolunteerFormWrapper>
            </Container>
            <Footer>
                <ShareDrawer
                    fullwidth={true}
                    backgroundColor={'#fff'}
                    newsletterSignUpVisible={true}
                />
                <PBVMFooter onClick={e => props.setOverlayPartnerVisible(true, e, true)}>
                    {'Powered by VolunteerMatch'}
                </PBVMFooter>
            </Footer>
        </Body>
    </TransitionContainer>
);

VolunteerStep2.propTypes = {
    volunteerOpportunity: PropTypes.object.isRequired,
    isBackTransition: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        return {
            volunteerOpportunity: state.volunteer.selectedVolunteerOpportunity,
            isSubmitting: state.volunteer.isSubmitting,
            isMobileResolution: state.widget.isMobileResolution,
            isBackTransition: state.volunteer.isBackTransition
        };
    },
    {
        onGoToStep,
        setOverlayPartnerVisible,
        cacheFormData
    }
)(VolunteerStep2);



// WEBPACK FOOTER //
// ./src/containers/Volunteer/VolunteerStep2.jsx